/**
 * Who is looking at the raffle.
 *
 * The raffle reads used to be gated on `!!token && !guestMode`, which turned a
 * guest's "I cannot load" into the page's "No draws scheduled". The backend now
 * serves the schedule, the current draw, history and results to anonymous
 * callers (scoped by the selected-country header), so a guest is a reader too.
 * Only `'none'` — no token and not a guest, i.e. mid-logout or not hydrated —
 * skips the request.
 */
export type RaffleViewerMode = 'player' | 'guest' | 'none';

export function raffleViewerMode(token: string | null | undefined, guestMode: boolean): RaffleViewerMode {
  if (guestMode) return 'guest';
  return token ? 'player' : 'none';
}

export function raffleReadsEnabled(mode: RaffleViewerMode): boolean {
  return mode !== 'none';
}
